import type { ReactNode } from "react";
import { createContext, useContext, useState } from "react";
import { GoogleAnalytics } from "@next/third-parties/google";

interface GAContextType {
  gaId: string;
  setGaId: (id: string) => void;
}

const GAContext = createContext<GAContextType>({
  gaId: "",
  setGaId: () => null
});

export const GoogleAnalyticsProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [gaId, setGaId] = useState<string>("");

  return (
    <GAContext.Provider value={{ gaId, setGaId }}>
      {children}
      {gaId ? <GoogleAnalytics gaId={gaId} /> : null}
    </GAContext.Provider>
  );
};

export const useGoogleAnalytics = () => useContext(GAContext);
